module.exports = __webpack_public_path__ + "producr-dried fresh-grass-08.jpg?3a2570845e4ba7a3153843157883d138";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-08.jpg
// module id = 66
// module chunks = 0